import { UnderConstruction } from "components/UnderConstruction";
import React from "react";

interface IAdminOrderSelectionProps {
  onSelectionComplete: () => void;
}
const AdminOrderSelection: React.FC<IAdminOrderSelectionProps> = () => {
  return (
    <div>
      <h1>Admin Order Page</h1>
      {/* Add your content here */}
      <UnderConstruction />
    </div>
  );
};

export default AdminOrderSelection;
